import Form from 'react-bootstrap/Form';
import './MachineForm.scss';
import { Machine } from '../../../utils/models/Machine';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ModalComponent from '../../ModalCompnent/modal.component';
import { useSelector } from 'react-redux';
import { selectUser } from '../../../utils/redux/userSlice';
import { Spinner } from 'react-bootstrap';
import { MachineTypes } from '../../../utils/const';
import { resetMachineData } from '../../../utils/services/machine.service';
import { formatNumberWithLeadingZeros } from 'aw-generic-functions';
import { IToastProps, NotificationToast } from 'aw-notificationtoast';
import ModalQRCode from '../../QRCodeFile/ModalQRCode/ModalQRCode.component';
import { ROLES } from 'aw-consts';
import { AWSelect } from 'aw-select';
import { useTheme } from '../../../utils/contexts/ThemeContext';

const MachineForm = (props: {
    formLock: boolean;
    edit: boolean;
    machineAux: Machine;
    sendChange: (event: any) => void;
    optionsContainers: any;
    selectedContainer: any;
    onChangeSelectContainer: (e: any) => void;
    onSetToken: (t: string) => void;
    onDownloadFile: (m: Machine) => void;
    onSelectedFile: (name: string, img: string) => void;
    token: string;
}) => {
    const { t } = useTranslation();

    const { machineAux } = props;
    const [showModalToken, setShowModalToken] = useState(false);
    const [showModalReset, setShowModalReset] = useState(false);
    const [loadingReset, setLoadingReset] = useState(false);
    const user = useSelector(selectUser);
    const [toast, setToast] = useState<IToastProps>({ showToast: false, msg: '', fail: false });
    const options = MachineTypes();
    const [showModalQR, setShowModalQR] = useState(false);

    const showToastTimeOut = (msg: string, failToast: boolean) => {
        setToast({ showToast: true, msg: msg, fail: failToast });
        setTimeout(() => setToast({ showToast: false, msg: msg, fail: failToast }), 2000);
    };

    const onInputChange = (event: any) => {
        props.sendChange(event);
    };

    const onGenToken = () => {
        setShowModalToken(true);
    };

    const genToken = () => {
        //const rand = crypto.randomUUID()
        const rand1 = Math.random().toString(15);
        const rand2 = Math.random().toString(15);
        props.onSetToken(rand1 + rand2);
        setShowModalToken(false);
    };

    const onDownloadFile = () => {
        props.onDownloadFile(machineAux);
    };

    const resetMachine = () => {
        setShowModalReset(false);
        setLoadingReset(true);
        resetMachineData(user.token, machineAux.idmachine)
            .then(response => {
                if (response.status >= 200 && response.status < 300) {
                    showToastTimeOut(t('MachineResetOk'), false);
                } else {
                    throw new Error();
                }
            })
            .catch(() => {
                showToastTimeOut(t('MachineResetFail'), false);
            })
            .finally(() => {
                setLoadingReset(false);
            });
    };

    const resetMachineClick = () => {
        if (user.role === ROLES.Demo) {
            showToastTimeOut(t('noResetPermissions'), true);
            return;
        }
        setShowModalReset(true);
    };


    const theme = useTheme();

    const dark = theme.theme==='dark';

    return (
        <>
            <NotificationToast showToast={toast.showToast} msg={toast.msg} fail={toast.fail} />
            <ModalComponent
                showModal={showModalToken}
                onClickNo={() => setShowModalToken(false)}
                onClickYes={() => {
                    genToken();
                }}
                textDel={t('DoYouWantToGenerateNewToken')}
            />
            <ModalComponent
                showModal={showModalReset}
                onClickNo={() => setShowModalReset(false)}
                onClickYes={() => {
                    resetMachine();
                }}
                textDel={t('DoYouWantToResetThisMachine')}
            />
            <ModalQRCode onHide={() => setShowModalQR(false)} showModal={showModalQR} machine={machineAux} />
            <div className="p-3 rounded-1" id="formMachineContainer">
                <Form>
                    <div className="row mb-3 mt-2">
                        <div className="col">
                            <Form.Check
                                disabled={props.formLock}
                                name="active"
                                type="checkbox"
                                label={t('Active')}
                                defaultChecked={machineAux.active}
                                onClick={onInputChange}
                            />
                        </div>
                        <div className="col"></div>
                        <div className="col text-end">
                            <button
                                type="button"
                                disabled={!(machineAux.token.length > 0)}
                                onClick={() => setShowModalQR(true)}
                                className="btn-Custom btn-IDGrey me-2"
                            >
                                <i className="bi bi-qr-code"></i>
                            </button>
                        </div>
                    </div>
                    <div className="row mb-3 mt-2">
                        <div className="col">
                            <Form.Label className="mb-0">{`${t('Identifier')}`}</Form.Label>
                            <Form.Control
                                disabled={true}
                                name="id"
                                type="text"
                                className="inputStyle"
                                onChange={onInputChange}
                                value={formatNumberWithLeadingZeros(machineAux.idmachine, 5)}
                            />
                        </div>
                        <div className="col"></div>
                        <div className="col text-end">
                            <button type="button" onClick={onDownloadFile} className="btn-Custom btn-IDGrey me-2">
                                <i className="bi bi-file-earmark-arrow-down"></i>
                            </button>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col-12 col-lg">
                            <Form.Label className="mb-0">{`${t('Name')}*`}</Form.Label>
                            <Form.Control disabled={props.formLock} name="name" className="inputStyle" type="text" onChange={onInputChange} value={machineAux.name} />
                        </div>
                        <div className="col-12 col-lg">
                            <Form.Label className="mb-0">{t('Type')}</Form.Label>
                            <Form.Control className="inputStyle" type="text" disabled={true} value={'4'}/>
                        </div>
                        <div className="col-12 col-lg">
                            <Form.Label className="mb-0">{t('Installation')}</Form.Label>
                            <AWSelect dark={dark}
                                disabled={props.formLock}
                                closeMenuOnSelect={true}
                                className="inputStyle selectStyle"
                                onChange={props.onChangeSelectContainer}
                                defaultValue={props.selectedContainer}
                                options={props.optionsContainers}
                            />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col-12 col-lg">
                            <Form.Label className="mb-0">{t('Model')}</Form.Label>
                            <Form.Control
                                disabled={true}
                                name="model"
                                type="text"
                                className="inputStyle"
                                onChange={onInputChange}
                                value={machineAux.model}
                            />
                        </div>
                        <div className="col-12 col-lg">
                            <Form.Label className="mb-0">{t('NSerie')}</Form.Label>
                            <Form.Control
                                disabled={true}
                                name="serial_number"
                                type="text"
                                className="inputStyle"
                                onChange={onInputChange}
                                value={machineAux.serial_number}
                            />
                        </div>
                        <div className="col-12 col-lg">
                            <Form.Label className="mb-0">V. Firmware HMI</Form.Label>
                            <Form.Control
                                disabled={true}
                                name="v_software"
                                type="text"
                                className="inputStyle"
                                onChange={onInputChange}
                                value={machineAux.v_firmware_hmi}
                            />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col-12 col-lg">
                            <Form.Label className="mb-0">Token</Form.Label>
                            <div className="row">
                                <div className="col">
                                    <Form.Control disabled={true} className="col-6 inputStyle" name="token" type="text" value={machineAux.token} />
                                </div>
                                <div className="col-2 text-end">
                                    <button type="button" onClick={onGenToken} disabled={props.formLock} className="btn-Custom btn-IDGrey me-2">
                                        <i className="bi bi-arrow-clockwise"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-lg">
                            <Form.Label className="mb-0">V. Firmware IO</Form.Label>
                            <Form.Control
                                disabled={true}
                                name="v_software"
                                type="text"
                                className="inputStyle"
                                onChange={onInputChange}
                                value={machineAux.v_firmware_io}
                            />
                        </div>
                        <div className="col-12 col-lg">
                            <Form.Label className="mb-0">HMI Mac</Form.Label>
                            <Form.Control
                                disabled={true}
                                name="v_software"
                                type="text"
                                className="inputStyle"
                                onChange={onInputChange}
                                value={machineAux.hmi_mac}
                            />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col"></div>
                        <div className="col"></div>
                        <div className="col-12 col-lg">
                            <Form.Label className="mb-0"></Form.Label>
                            <div className="resetContainer">
                                {loadingReset ? (
                                    <div>
                                        <Spinner animation="border" variant="success" />
                                    </div>
                                ) : (
                                    <button type="button" onClick={resetMachineClick} disabled={props.formLock} className="btn-Custom btn-IDRed me-2">
                                        <i className="bi bi-arrow-repeat"></i>
                                    </button>
                                )}
                                <Form.Label className="mt-1 mb-0 me-2 resetText">{`${t('ResetMachineData')}`}</Form.Label>
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        </>
    );
};
export default MachineForm;
